import { useCancelMadinaManifestMutation, useCompleteMadinaManifestMutation, useDownloadMadinaTafweejManifestMutation, useGetMadinaManifestsQuery } from "@/services/arrivals/madinah/arrival.madinah";
import { useUnassignBagMutation } from "@/services/madinah/bag";

export const usePorts = ({
    queryParams,
    isFromPorts,
}) => {

    // =================
    // Side Effects
    // =================
    // -- mutations
    const { mutate: downloadMadinaTafweejManifestMutation, isPending: isDownloadMadinaTafweejManifestPending } = useDownloadMadinaTafweejManifestMutation();
    const { mutate: cancelMutation, isPending: isCancelPending } = useCancelMadinaManifestMutation();
    const { mutate: unassignMutation, isPending: isUnassignPending } = useUnassignBagMutation();
    const { mutate: completeMutation, isPending: isCompletePending } = useCompleteMadinaManifestMutation();
    // -- queries
    const { data: manifestsRes, isLoading, isFetching } = useGetMadinaManifestsQuery(queryParams, isFromPorts);
    // -- data
    const data = manifestsRes?.data?.data || [];
    const meta = manifestsRes?.data?.meta || {};
    const loading = isLoading || isFetching;
    const isPending = isCancelPending || isUnassignPending || isCompletePending || isDownloadMadinaTafweejManifestPending;

    return {
        data,
        meta,
        cancelMutation,
        unassignMutation,
        completeMutation,
        downloadMadinaTafweejManifestMutation,
        loading,
        isPending
    }
}